import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ContractTypeFormatTable from "../../../componentes/contractTypeConfiguration/contractTypeFormatTable";
import FormatClauses from "../../../componentes/contractTypeConfiguration/formatClauses";
import DialogClauses from "../../../componentes/contractTypeConfiguration/dialogClauses";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import { getTipoDeContrato } from "../../../actions/dummy-actions";
import { ERROR_MESSAGE } from "../../../constants";
import { useStateValue } from "../../../context/store";

import {
  updateContractTypeClausesFormat,
  getClausesByContractTypeFormat,
} from "../../../actions/contract-type-actions";
import { getAllClauses } from "../../../actions/clauses-actions";

const ContractTypeConfiguration = (props) => {
  const [{ breadCrumb }, dispatch] = useStateValue();
  const { contractTypeId, contractTypeName } = props.match.params;
  const [open, setOpen] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [contracType, setContractType] = useState(false);
  const [clausesByContractType, setClausesByContractType] = useState([]);
  const [clausesList, setClausesList] = useState([]);
  const [nameTypeContract, setNameTypeContract] = useState("");
  const contractTypes = getTipoDeContrato();
  const [updateId, setUpdateId] = useState(null);
  const [hasChangesClauses, setHasChangesClauses] = useState(false);
  const [hasChangesOrderClauses, setHasChangesOrderClauses] = useState(false);
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    oneButtons: false,
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });

  useEffect(() => {
    getClauses();
    getClausesList();
  }, []);

  const getClausesList = async () => {
    const response = await getAllClauses(
      {
        page: 0,
        size: 100,
        order: "DESC",
        columnOrder: "name",
      },
      dispatch
    );
    setClausesList(response.data.content);
  };

  const getClauses = async () => {
    const clauses = await getClausesByContractTypeFormat(contractTypeId, dispatch);
    setClausesByContractType(clauses.data.clauses);
    setContractType(clauses.data.contractType);
    setUpdateId(clauses.data.id);
  };

  useEffect(() => {
    // const typeContract = contractTypes.find(
    //   (cont) => cont.key === contractTypeName
    // );
    setNameTypeContract(contractTypeName);
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onSave = (listClauses,previousPage= null) => {
    if (
      listClauses === null ||
      listClauses?.length === 0 ||
      listClauses === undefined
    ) {
      return;
    }

    setOpen(false);

    const listClausesToSend = listClauses?.filter(
      (clause) => clause.tipoContrato === true
    );

    const clauseList = listClausesToSend.map((clause, index) => ({
      id: clause.id,
      order: index + 1,
    }));
    let contractTypeClauses = {
      contractTypeFormatId : contractTypeId,
      clauseList,
    };

    const updateContractTypeClausesAsync = async () => {
      const saveResponse = await updateContractTypeClausesFormat(
        contractTypeClauses,
        dispatch
      );
      if (
        saveResponse &&
        saveResponse.status >= 200 &&
        saveResponse.status < 399
      ) {
        setConfirm(() => ({
          open: true,
          question: `Se actualizó la lista de cláusulas exitosamente`,
          type: "SUCCESS",
          handleClick: ()=>closeMessage(previousPage),
          oneButtons: true,
        }));
        setHasChangesClauses(!hasChangesClauses);
        getClauses();
      } else {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: saveResponse?.data?.detail
              ? saveResponse?.data?.detail
              : ERROR_MESSAGE,
          },
        });
      }
    };
    updateContractTypeClausesAsync();
  };

  if (breadCrumb?.handleSaveOrderClauses) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configurar Formato de contrato",
      breadCrumbSubText: "Configurar Formato de contrato",
      index: 16,
      handleSaveOrderClauses: false,
    });

    setTimeout(() => {
      if (hasChangesOrderClauses) {
        onSave(clausesByContractType,"previousPage");
      } else {
        props.history.push(`/dashboard/type-contracts`);
      }
    }, 100);
  }

  const closeMessage = (previousPage) => {
    if(previousPage=== "previousPage"){
      props.history.push(`/dashboard/type-contracts`);
    }
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  return (
    <React.Fragment>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        type={confirm.type}
        oneButtons={confirm.oneButtons}
        title={confirm.title}
      />
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <h3>Formato Tipo {nameTypeContract}</h3>
            </Grid>
            <Grid item xs={6}>
              <Button
                style={{
                  float: "right",
                  backgroundColor: "#7EBDCE",
                  color: "#ffffff",
                }}
                onClick={handleClickOpen}
              >
                Asociar Cláusula
              </Button>
            </Grid>
          </Grid>
          <ContractTypeFormatTable
            clauses={clausesByContractType}
            contracType={contracType}
          />
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            paddingLeft: "60px",
            paddingTop: "64px",
          }}
        >
          <FormatClauses
            contractTypeId={contractTypeId}
            setClausesByContractType={setClausesByContractType}
            hasChangesClauses={hasChangesClauses}
            setHasChangesOrderClauses={setHasChangesOrderClauses}
          />
        </Grid>
      </Grid>
      {open && (
        <DialogClauses
          open={open}
          handleClose={onClose}
          handleSave={onSave}
          contractTypeId={contractTypeId}
          checkAll={checkAll}
          setCheckAll={setCheckAll}
        />
      )}
    </React.Fragment>
  );
};

export default ContractTypeConfiguration;
